// 0.42 is MUI's input placeholder opacity in light mode (MuiInputBase).
export const SELECT_PLACEHOLDER_SX = {
  opacity: 0.42,
} as const;
